// Widgetlar (features/widgets): yuqori panel, panel, soat, en — manba
export default {
  title: "Widgets",
  edit: "Edit widgets",
  done: "Done",
  add: "Add widget",
  addThis: "Add",
  back: "Back",
  pin: "Pin to the side",
  unpin: "Unpin",
  empty: "No widgets yet",
  emptyHint: "Add a world clock to see US time at a glance.",
  full: "Up to {{n}} widgets",
  removed: "{{name}} removed",
  undo: "Undo",
  removeWidget: "Remove widget",
  removeNamed: "Remove {{name}}",
  editWidget: "Edit {{name}}",
  showTop: "Show in the top bar",
  topFull: "up to {{n}} widgets",
  sizeLabel: "Size",
  size: { s: "Small", m: "Medium", l: "Large" },
  menu: {
    settings: "Settings",
    size: "Size",
    showTop: "Show in the top bar",
    hideTop: "Hide from the top bar",
    remove: "Remove",
  },
  failed: "This widget could not be shown.",
  loadFailed: "Could not load widgets.",
  retry: "Retry",
  conflict: "Widgets were changed in another window. Showing the latest.",
  saveFailed: "Could not save widgets.",
  calendar: {
    title: "Calendar",
    description: "Reminders, start days, carrier payment due dates and document expiries in one month view.",
    glance_one: "{{count}} today",
    glance_other: "{{count}} today",
    today: "Today",
    tomorrow: "Tomorrow",
    empty: "Nothing coming up",
    emptyDay: "Nothing on this day",
    prev: "Previous month",
    next: "Next month",
    kindsTitle: "Show",
    showDone: "Show completed reminders",
    kinds: {
      reminder: "Reminders",
      start: "Start / orientation days",
      fee: "Carrier payment due",
      expiry: "Document expiries",
      available: "Driver available from",
      assignment: "Assignment ends",
    },
  },
  callnow: {
    title: "Call now",
    description: "Your drivers whose local time is within call hours, reminders first.",
    now: "can be called now",
    reminder: "reminder",
    never: "no calls yet",
    daysAgo_one: "{{count}} day ago",
    daysAgo_other: "{{count}} days ago",
    empty: "Nobody to call right now",
    callHint: "Local time of the driver's state.",
    limit: "List length",
  },
  shift: {
    title: "Shift",
    description: "Time left in your shift and which US zones are in business hours.",
    left: "left",
    ended: "ended",
    startsIn: "starts in",
    elapsed: "{{time}} elapsed",
    usHours: "US business hours",
    start: "Start",
    end: "End",
    hint: "In your time zone ({{tz}}). A shift may cross midnight.",
  },
  goal: {
    title: "Monthly goal",
    description: "Approved hires this month against the goal, like an activity ring.",
    hires: "hires",
    monthTitle: "This month",
    remaining_one: "{{count}} more to the goal",
    remaining_other: "{{count}} more to the goal",
    ahead_one: "{{count}} ahead of pace",
    ahead_other: "{{count}} ahead of pace",
    behind_one: "{{count}} behind pace",
    behind_other: "{{count}} behind pace",
    onPace: "On pace",
    day: "day {{day}} of {{days}}",
    bonus: "{{amount}} per hire",
    noGoal: "No goal set",
    noGoalOwner: "Set the goal in Settings → Bonus rule",
  },
  starts: {
    title: "Upcoming starts",
    description: "Drivers starting or in orientation in the next days, with their local time.",
    within: "start within {{days}} days",
    empty: "No starts in the next {{days}} days",
    daysLabel: "Look ahead",
    days_one: "{{count}} day",
    days_other: "{{count}} days",
  },
  fees: {
    title: "Carrier payments",
    description: "Overdue and upcoming carrier payments with the remaining amount.",
    overdue_one: "{{count}} overdue",
    overdue_other: "{{count}} overdue",
    soon_one: "{{count}} due in {{days}} days",
    soon_other: "{{count}} due in {{days}} days",
    soonShort: "{{amount}} due in {{days}} days ({{count}})",
    empty: "Nothing overdue or due soon",
    daysLabel: "Due within",
  },
  note: {
    title: "Note",
    description: "A quick note while on a call. Saved on the server, visible on every device.",
    placeholder: "Type a note…",
    empty: "Empty note",
  },
  recent: {
    title: "Recently opened",
    description: "The last drivers and carriers you opened on this device.",
    empty: "Nothing opened yet",
  },
  rate: {
    title: "Exchange rate",
    description: "USD to UZS by the Central Bank, with the last 30 days.",
    usd: "1 USD",
    week: "7 days",
    cbu: "Central Bank",
    manual: "set manually",
    none: "No rate yet",
    days_one: "{{count}} day",
    days_other: "{{count}} days",
  },
  clock: {
    title: "World clock",
    description: "US time zones and yours. The large size shows when it is a good time to call.",
    day: { today: "Today", tomorrow: "Tomorrow", yesterday: "Yesterday" },
    hours: "{{value}} h",
    now: "Now",
    callLegend: "Call hours {{from}}–{{to}} local time",
    zones: "Time zones",
    reorder: "Drag to reorder",
    label: "Name for {{city}}",
    removeZone: "Remove {{city}}",
    search: "City or state (TX)",
    noResults: "Nothing found",
    addUs: "US zones",
    maxZones: "Up to {{n}} time zones.",
    seconds: "Second hand",
    format: "Time format",
    formatAuto: "Auto ({{value}}-hour)",
    format24: "24-hour",
    format12: "12-hour",
    callHours: "Call hours",
    callFrom: "From",
    callTo: "To",
    callHint: "Local time in each zone; green on the large size.",
    cities: {
      "America/New_York": "New York",
      "America/Chicago": "Chicago",
      "America/Denver": "Denver",
      "America/Phoenix": "Phoenix",
      "America/Los_Angeles": "Los Angeles",
      "America/Anchorage": "Anchorage",
      "Pacific/Honolulu": "Honolulu",
      "Asia/Tashkent": "Tashkent",
      "Asia/Samarkand": "Samarkand",
      "Europe/Moscow": "Moscow",
      "Europe/London": "London",
      "Europe/Istanbul": "Istanbul",
      "Asia/Dubai": "Dubai",
      UTC: "UTC",
    },
  },
};
